import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const CopyIcon: FC<IconProps> = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M16 8V5.2c0-1.1201 0-1.6802-.218-2.108a1.9997 1.9997 0 0 0-.874-.874C14.4802 2 13.9201 2 12.8 2H5.2c-1.1201 0-1.6802 0-2.108.218a1.9999 1.9999 0 0 0-.874.874C2 3.5198 2 4.08 2 5.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 16 4.08 16 5.2 16H8m3.2 6h7.6c1.1201 0 1.6802 0 2.108-.218a1.9996 1.9996 0 0 0 .874-.874C22 20.4802 22 19.9201 22 18.8v-7.6c0-1.1201 0-1.6802-.218-2.108a1.9997 1.9997 0 0 0-.874-.874C20.4802 8 19.9201 8 18.8 8h-7.6c-1.1201 0-1.6802 0-2.108.218a1.9999 1.9999 0 0 0-.874.874C8 9.5198 8 10.08 8 11.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C9.5198 22 10.08 22 11.2 22Z"
        />
    </svg>
);